<div class="mat-typography">
    <div class="dialog-header">
        <span>Layers Info</span>
        <inline-svg src="small_close.svg" mat-dialog-close
                    matTooltip="Close" class="close-icon"
                    color="#A5B5BD"
                    hoverColor="#7F8F98"></inline-svg>
    </div>
    <div class="horizontal-separator"></div>

    <div class="dialog-container" #container [ngStyle]="{'padding-right': (hasScroll?16 : 36)  + 'px'}">
        <mat-accordion multi>
            @for (layer of layersHelpInfo; track layer.title) {
            <mat-expansion-panel resizeObserver (resized)="checkForScroll()">
                <mat-expansion-panel-header >
                    <mat-panel-title> {{layer.title}} </mat-panel-title>
                </mat-expansion-panel-header>
                <span>{{layer.description}}</span>
            </mat-expansion-panel>
            }
        </mat-accordion>
    </div>

</div>
